import { Navigate } from "react-router-dom";
import { useAppSelector } from "../../redux/hooks";

const PublicRoute = ({ children }) => {
  const token = useAppSelector((state) => state.auth.token);

  if (token) {
    return <Navigate to="/dashboard" replace />;
  } else {
  }
  return children;
};

export default PublicRoute;
